import React from 'react'
import { ProductCard } from 'features/ECommerce/screens/AllProducts/components/ProductCard'
import { useFetchRelatedProducts } from 'features/ECommerce/api/queries/useFetchRelatedProducts'
import { Cards } from 'features/ECommerce/screens/AllProducts/components/ProductTypeSection/ProductTypeSection.styles'
import { useAddToCart } from 'features/ECommerce/hooks/useAddToCart'

type RelatedProductListProps = {
  slug: string
}

export const RelatedProductsList = ({ slug }: RelatedProductListProps) => {
  const { data, status } = useFetchRelatedProducts(slug)

  const addToCart = useAddToCart()

  if (status === 'loading' || status === 'idle' || status === 'error') return null
  return (
    <Cards>
      {data.products.map((product) => {
        if (product.slug !== slug)
          return <ProductCard product={product} key={product.productId} onAdd={addToCart} />
      })}
    </Cards>
  )
}

RelatedProductsList.displayName = 'RelatedProductsList'
